import React from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts"; // ✅ make sure this path is correct in React
import moment from "moment";
import { colorsArray } from "../../util";

type DatasetType = {
  name: string;
  data: number[];
  color: string;
  time: string[];
  id: number | string;
};

type LineChartProps = {
  id: number;
  dataset: DatasetType[];
  formData: any;
};

const LineChart: React.FC<LineChartProps> = ({ id, dataset, formData }) => {
  const options = (data: DatasetType): ApexOptions[] => {
    return [
      {
        chart: {
          type: "line",
          zoom: {
            type: "x",
          },
          background: "transparent",
        },
        // ❌ Removed Next.js theme handling (you can use context or props instead)
        colors: colorsArray,
        stroke: {
          width: [2, 2, 2, 2, 2, 2, 2, 2, 2],
        },
        plotOptions: {
          bar: {
            columnWidth: "20%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          categories: data?.time,
          labels: {
            show: true,
            datetimeUTC: false,
            format:
              (+moment(formData.end_time) - +moment(formData.start_time)) /
                (1000 * 3600 * 24) >
              2
                ? "dd MMM"
                : "hh.mmTT",
          },
        },
        grid: {
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        yaxis: dataset?.map((data, index) => {
          const unitMatch = data.name.match(/\((.*?)\)/);
          const unit = unitMatch ? unitMatch[1] : "";

          return {
            show: true,
            opposite: (index + 1) % 2 === 0,
            labels: {
              style: { colors: colorsArray[index] },
              formatter: (value: any) =>
                unit ? `${value} ${unit}` : `${value}`,
            },
            axisBorder: {
              show: true,
              color: colorsArray[index],
            },
            axisTicks: { show: true },
            title: {
              text: data.name,
              style: { color: colorsArray[index] },
            },
            // ✅ push each y-axis a bit outward
            offsetX: (index + 1) % 2 === 0 ? 20 : -20,
          };
        }),

        tooltip: {
          enabled: true,
          x: {
            formatter: (val: number) =>
              moment(val).format("DD MMM YYYY / hh.mm A"),
          },
          y: {
            formatter: (val: number) => val?.toFixed(2),
          },
        },
        legend: {
          show: true,
          horizontalAlign: "center",
          offsetX: 40,
        },
      },
    ];
  };

  return (
    <ReactApexChart
      options={options(dataset[0])[0]}
      series={dataset}
      type="line"
      width={"100%"}
      height={"100%"}
      // height="100%"
    />
  );
};

export default LineChart;
